import {
  Component,
  EventEmitter,
  OnInit,
  Output,
  ChangeDetectorRef,
} from '@angular/core';
import { IExtracaoRelatorioForm } from './modal-extracao-relatorio-layout.model';
import { ToastrService } from 'ngx-toastr';
import { AppExportBase64 } from '../../../../services/exportBase64/exportBase64.service';
import { PermissionService } from '../../../../services/permission.service';
import { HttpService } from '../../../../services/common/http/common.http.service';
import Swal from 'sweetalert2';
@Component({
  selector: 'app-modal-extracao-relatorio-layout',
  templateUrl: './modal-extracao-relatorio-layout.component.html',
  styleUrls: ['./modal-extracao-relatorio-layout.component.scss'],
})
export class ExtracaoRelatorioLayoutComponent implements OnInit {
  @Output() inputClose = new EventEmitter<boolean>();
  visible: boolean = true;
  loader: boolean = false;

  constructor(
    private httpService: HttpService,
    private exportBase64Service: AppExportBase64,
    private toast: ToastrService,
    private permissionService: PermissionService,
    private changeDetectorRef: ChangeDetectorRef
  ) {}

  ngOnInit() {
    this.permissionService.getPermission();
    this.populateAnoOptions();
    this.visible = true;
    this.changeDetectorRef.detectChanges();
  }

  form: IExtracaoRelatorioForm = {
    mes: 0,
    ano: 0,
  };

  mesOptions = [
    { name: 'Janeiro', value: 1 },
    { name: 'Fevereiro', value: 2 },
    { name: 'Março', value: 3 },
    { name: 'Abril', value: 4 },
    { name: 'Maio', value: 5 },
    { name: 'Junho', value: 6 },
    { name: 'Julho', value: 7 },
    { name: 'Agosto', value: 8 },
    { name: 'Setembro', value: 9 },
    { name: 'Outubro', value: 10 },
    { name: 'Novembro', value: 11 },
    { name: 'Dezembro', value: 12 },
  ];

  anoOptions: any[] = [];

  populateAnoOptions() {
    const startYear = 2024;
    const currentYear = new Date().getFullYear();
    for (let year = startYear; year <= currentYear; year++) {
      this.anoOptions.push({ name: year.toString(), value: year });
    }
  }

  extrairRelatorio() {
    this.loader = true;
    let funcionarioLocal = JSON.parse(
      String(localStorage.getItem('Funcionario'))
    );

    const body = {
      Mes: this.form.mes,
      Ano: this.form.ano,
      FuncionarioId: Number(funcionarioLocal.IdFuncionario),
    };

    let message = (status: boolean) => {
      if (status) {
        Swal.fire({
          title: 'Atenção',
          text: 'Verifique se a informações estão corretas. Não existem dados nesse período informado.',
          icon: 'error',
          confirmButtonText: 'Fechar',
          confirmButtonColor: 'orange',
        });
      }
    };

    this.httpService.usePostFilter('ApontamentoMensalXlsx', body).subscribe({
      next: (response: any) => {
        if (response.IsSuccess) {
          Swal.fire({
            title: 'Relatório enfileirado',
            icon: 'success',
            text: 'A planilha está sendo gerada. Em alguns minutos você receberá o e-mail com o anexo. Se não chegar, verifique spam ou contate o suporte.',
            confirmButtonColor: 'green',
            confirmButtonText: 'Confirmar',
          });

          this.loader = false;
        } else {
          message(true);
        }
        this.loader = false;
        this.inputClose.emit(true);
      },
      error: (_error) => {
        message(true);
        this.loader = false;
      },
      complete: () => {
        this.loader = false;
      },
    });
  }

  validarForm() {
    if (!this.form.mes || !this.form.ano) {
      return false;
    }
    return true;
  }
}
